import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DateInput from './DateInput';

// "Pricelist Sent" filter fields (issue #241), shared by the Leads and
// Customers lists' Filters drawer/SavedFilterTabs so both screens stay
// identical. Matches on the Pricelist's scope (Customer Price Group +
// Product Price Group) rather than a specific Pricelist, so a scope's
// received/not received result carries across a Pricelist being replaced
// by a newer one for the same scope — see backend
// services/pricelistSendFilter.js.
export const DEFAULT_PRICELIST_SENT_FILTERS = {
  pricelist_sent: '',
  pricelist_customer_price_group_id: '',
  pricelist_product_price_group_id: '',
  pricelist_sent_from: '',
  pricelist_sent_to: '',
};

export function pricelistSentParams(filters) {
  if (!filters.pricelist_sent) return {};
  const params = {};
  Object.keys(DEFAULT_PRICELIST_SENT_FILTERS).forEach((key) => {
    if (filters[key]) params[key] = filters[key];
  });
  return params;
}

// Dependency list for a table's fetch effect — one stable string, so
// adding a field here never needs every consumer's deps array touched.
export function pricelistSentFilterKey(filters) {
  return Object.keys(DEFAULT_PRICELIST_SENT_FILTERS).map((key) => filters[key] || '').join('|');
}

export default function PricelistSentFilterFields({ draft, setDraftField, labelStyle, inputStyle }) {
  const [customerPriceGroups, setCustomerPriceGroups] = useState([]);
  const [productPriceGroups, setProductPriceGroups] = useState([]);

  useEffect(() => {
    axios.get('/api/customer-price-groups', { params: { status: 'active' } })
      .then((res) => setCustomerPriceGroups(res.data.data || []))
      .catch(() => setCustomerPriceGroups([]));
    axios.get('/api/product-price-groups')
      .then((res) => setProductPriceGroups((res.data.data || []).filter((g) => g.is_active)))
      .catch(() => setProductPriceGroups([]));
  }, []);

  const inactive = !draft.pricelist_sent;

  return (
    <>
      <div>
        <label style={labelStyle}>Pricelist Sent</label><br />
        <select className="styled-input" value={draft.pricelist_sent || ''} onChange={(e) => setDraftField('pricelist_sent', e.target.value)} style={inputStyle}>
          <option value="">Any</option>
          <option value="received">Received</option>
          <option value="missing">Not received</option>
        </select>
      </div>
      <div>
        <label style={labelStyle}>Pricelist Customer Scope</label><br />
        <select className="styled-input" disabled={inactive} value={draft.pricelist_customer_price_group_id || ''} onChange={(e) => setDraftField('pricelist_customer_price_group_id', e.target.value)} style={inputStyle}>
          <option value="">Any price group</option>
          {customerPriceGroups.map((g) => (
            <option key={g.id} value={g.id}>{'   '.repeat(g.depth || 0)}{g.name}</option>
          ))}
        </select>
      </div>
      <div>
        <label style={labelStyle}>Pricelist Product Scope</label><br />
        <select className="styled-input" disabled={inactive} value={draft.pricelist_product_price_group_id || ''} onChange={(e) => setDraftField('pricelist_product_price_group_id', e.target.value)} style={inputStyle}>
          <option value="">Any product scope</option>
          <option value="all">All products</option>
          {productPriceGroups.map((c) => (
            <option key={c.id} value={c.id}>{'   '.repeat(c.depth || 0)}{c.name}</option>
          ))}
        </select>
      </div>
      <div>
        <label style={labelStyle}>Pricelist Sent From</label><br />
        <DateInput className="styled-input" disabled={inactive} value={draft.pricelist_sent_from || ''} onChange={(e) => setDraftField('pricelist_sent_from', e.target.value)} style={inputStyle} />
      </div>
      <div>
        <label style={labelStyle}>Pricelist Sent To</label><br />
        <DateInput className="styled-input" disabled={inactive} value={draft.pricelist_sent_to || ''} onChange={(e) => setDraftField('pricelist_sent_to', e.target.value)} style={inputStyle} />
      </div>
    </>
  );
}
